module.exports = __webpack_public_path__ + "static/media/01-start.63ff0720.png";